export default {"src":"/_next/static/media/mediator.86eb4946.svg","height":66,"width":65,"blurWidth":0,"blurHeight":0};